import Vuex from 'vuex'
import Vue from 'vue'
import {
  getUserId,
  getUserLogin,
  getUserGrade,
  getGradeName,
  getShopUrl,
  getWindow,
  getUserStatus,
  getCyf,
  getNotice,
  getProd
} from '@/utils/http'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    meta:'',// 当前页描述
    login: getUserLogin(), //用户名
    id: getUserId(), //用户id
    user_grade: getUserGrade(), //会员等级
    grade_name: getGradeName(), //等级名称
    url: getShopUrl(), //店铺链接
    cate_window: getWindow(), //是否开启橱窗
    user_status: getUserStatus(), //获取用户账号是否审核通过
    cyf_switch: getCyf(), //材云发菜单控制
    msg_count: getNotice(), //通知中心红点
    prod_status: getProd(), //实地商家标志
  },
  mutations: {
    SET_LOGIN: (state, login) => {
      state.login = login
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_USER_GRADE: (state, user_grade) => {
      state.user_grade = user_grade
    },
    SET_GRADE_NAME: (state, grade_name) => {
      state.grade_name = grade_name
    },
    SET_SHOP_URL: (state, url) => {
      state.url = url
    },
    SET_CATE_WINDOW: (state, cate_window) => {
      state.cate_window = cate_window
    },
    SET_USER_STATUS: (state, user_status) => {
      state.user_status = user_status
    },
    SET_Cyf: (state, cyf_switch) => {
      state.cyf_switch = cyf_switch
    },
    SET_NOTICE: (state, msg_count) => {
      state.msg_count = msg_count
    },
    SET_PROD: (state, prod_status) => {
      state.prod_status = prod_status
    },
    SET_META: (state, meta) => {
      state.meta = meta
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js